import React from 'react';
import './Hero.css'
const Hero = () => {
    return (
        <div className="hero-section">
             <h1 className="heading">Wedding Ceremony</h1>
             <p className="para">In this Ceremony,<u> <b>MD: Junayed Hawladar Raj</b></u> And  <u><b>Megla</b></u> is Getting Married And This list Define all the familly Members Whom Can be in invited</p>
             <h2 className="secondary">Our Wedding Budget : 10millon </h2>
        </div>
    );
};

export default Hero;